import FroalaEditor from "froala-editor";
import { i18n } from "@/i18n/index";
import icons from "../FroalaIcons";

Object.assign(FroalaEditor.POPUP_TEMPLATES, {
    "richTextBlockPlugin.popup": "[_TITLE_]"
});

FroalaEditor.PLUGINS.richTextBlockPlugin = function (editor) {
    let el;
    let name;
    const coords = {
        top: 0,
        left: 0,
        offset: 0
    };

    function setPopupPosition() {
        coords.left = el.offset().left;
        coords.top = el.offset().top - 50;
        coords.offset = 0;
    }

    function createPopupTemplate() {
        const settings = i18n.t("froala.settings");
        const deleteBlock = i18n.t("froala.delete");
        const addBefore = i18n.t("froala.addBefore");
        const addAfter = i18n.t("froala.addAfter");
        return {
            title: `<div class="rich-text-popup" style="background-color: #BF4AE2"><span>${name}</span>
         <div style="display: inline" class="fr-btn"  data-title="${addBefore}">
         <svg class="fr-svg fr-command" data-cmd="lineBeforeRichText" viewBox="0 0 24 24" width="24px" height="24px">${icons.lineBefore}</svg>
         </div>
            <div style="display: inline" class="fr-btn"  data-title="${addAfter}">
            <svg class="fr-svg fr-command" data-cmd="lineAfterRichText" viewBox="0 0 24 24" width="24px" height="24px">${icons.lineAfter}</svg>
            <span class="delimiter">|</span>
            </div>
            <div style="display: inline" class="fr-btn"  data-title="${settings}">
            <svg class="fr-svg fr-command" data-cmd="richTextSettings" viewBox="0 0 24 24" width="24px" height="24px">${icons.settings}</svg>
            <span class="delimiter">|</span>
            </div>
            <div style="display: inline" class="fr-btn"  data-title="${deleteBlock}">
            <svg class="fr-svg fr-command" data-cmd="deleteRichTextBlock" viewBox="0 0 24 24" width="24px" height="24px">${icons.delete}</svg>
            </div>
            </div>`
        };
    }

    function scrollBlockMenu() {
        if (editor.popups.isVisible("richTextBlockPlugin.popup")) {
            setPopupPosition();
            editor.popups.show("richTextBlockPlugin.popup", coords.left, coords.top, coords.offset);
        }
    }

    function initPopup(fromNotif) {
        const popup = editor.popups.get("richTextBlockPlugin.popup");
        if (popup) {
            popup.remove();
        }
        const template = createPopupTemplate();
        editor.popups.create("richTextBlockPlugin.popup", template);
        editor.popups.setContainer("richTextBlockPlugin.popup", editor.$("#doc-builder"));
        const blockMenu = editor.popups.get("richTextBlockPlugin.popup");
        if (fromNotif) {
            blockMenu.attr("id", "rich-text-block-menu-notif");
        } else {
            blockMenu.attr("id", "rich-text-block-menu");
        }
        if (editor.$wp) {
            editor.$wp.off(`scroll.richTextBlockPlugin.popup.ed${editor.id}`, scrollBlockMenu);
            editor.$wp.off(`scroll.richTextBlockPlugin.popup.ed${editor.sid}`, scrollBlockMenu);
            editor.$wp[0]["data-events"] = [];
            editor.events.$on(editor.$wp, "scroll.richTextBlockPlugin.popup", scrollBlockMenu);
        }
    }

    function showPopup(elem, fromNotif) {
        el = elem;
        name = el.attr("data-name");
        if (!name) {
            if (!editor.vueInstance.currentDoc.richTextCounter) {
                editor.vueInstance.currentDoc.richTextCounter = 0;
            }
            editor.vueInstance.currentDoc.richTextCounter += 1;
            const counter = editor.vueInstance.currentDoc.richTextCounter;
            name = `Rich Text block ${counter}`;
            el.attr("data-name", name);
        }
        initPopup(fromNotif);
        setPopupPosition();
        el.addClass("selected");
        if (!editor.popups.isVisible("table.edit")) {
            editor.popups.show("richTextBlockPlugin.popup", coords.left, coords.top, coords.offset);
        } else {
            editor.popups.show("richTextBlockPlugin.popup", coords.left, coords.top, coords.offset);
            editor.popups.show("table.edit");
        }
        editor.popups.onHide("richTextBlockPlugin.popup", () => {
            el.removeClass("selected");
        });
    }

    function setVisible(fromNotif) {
        el.addClass("selected");
        if (fromNotif) {
            editor.$("#rich-text-block-menu-notif").addClass("fr-active");
        } else {
            editor.$("#rich-text-block-menu").addClass("fr-active");
        }
    }

    function openSettings() {
        editor.vueInstance.openRichTextSettings(name);
    }

    function hidePopup() {
        editor.popups.hide("richTextBlockPlugin.popup");
    }

    function applySettings({ name: newName = "" } = {}) {
        el.attr("data-name", newName);
        editor.events.trigger("contentChanged");
        hidePopup();
    }

    function deleteRichTextBlock() {
        el.remove();
        hidePopup();
        editor.toolbar.enable();
    }

    function insertLine(before) {
        const line = "<p><br/></p>";
        editor.popups.hideAll();
        if (before) {
            el.before(line);
        } else {
            el.after(line);
        }
    }

    return {
        showPopup,
        setVisible,
        hidePopup,
        openSettings,
        applySettings,
        deleteRichTextBlock,
        insertLine
    };
};
FroalaEditor.DefineIcon("richTextBlock", { template: "textSVG", PATH: icons.richText, NAME: i18n.t("froala.richTextBlock") });
FroalaEditor.DefineIcon("lineBefore", { template: "customSVG", PATH: icons.lineBefore });
FroalaEditor.DefineIcon("lineAfter", { template: "customSVG", PATH: icons.lineAfter });

FroalaEditor.RegisterCommand("richTextSettings", {
    title: null,
    undo: false,
    focus: true,
    callback() {
        this.richTextBlockPlugin.openSettings();
    },
    plugin: "richTextBlockPlugin"
});

FroalaEditor.RegisterCommand("deleteRichTextBlock", {
    title: null,
    undo: true,
    focus: true,
    callback() {
        this.richTextBlockPlugin.deleteRichTextBlock();
    },
    plugin: "richTextBlockPlugin"
});

FroalaEditor.RegisterCommand("lineBeforeRichText", {
    title: null,
    undo: true,
    focus: false,
    callback() {
        this.richTextBlockPlugin.insertLine(true);
    },
    plugin: "richTextBlockPlugin"
});

FroalaEditor.RegisterCommand("lineAfterRichText", {
    title: null,
    undo: true,
    focus: false,
    callback() {
        this.richTextBlockPlugin.insertLine(false);
    },
    plugin: "richTextBlockPlugin"
});
